/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PagedResponse } from './PagedResponse';
import {
    PagedResponseFromJSON,
    PagedResponseFromJSONTyped,
    PagedResponseToJSON,
} from './PagedResponse';
import type { ParentRole } from './ParentRole';
import {
    ParentRoleFromJSON,
    ParentRoleFromJSONTyped,
    ParentRoleToJSON,
} from './ParentRole';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface ParentRoleSearchResponse
 */
export interface ParentRoleSearchResponse extends PagedResponse {
    /**
     * 
     * @type {Array<ParentRole>}
     * @memberof ParentRoleSearchResponse
     */
    roles: Array<ParentRole>;
}

/**
 * Check if a given object implements the ParentRoleSearchResponse interface.
 */
export function instanceOfParentRoleSearchResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roles" in value;

    return isInstance;
}

export function ParentRoleSearchResponseFromJSON(json: any): ParentRoleSearchResponse {
    return ParentRoleSearchResponseFromJSONTyped(json, false);
}

export function ParentRoleSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentRoleSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PagedResponseFromJSONTyped(json, ignoreDiscriminator),
        'roles': ((json['roles'] as Array<any>).map(ParentRoleFromJSON)),
    };
}

export function ParentRoleSearchResponseToJSON(value?: ParentRoleSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PagedResponseToJSON(value),
        'roles': ((value.roles as Array<any>).map(ParentRoleToJSON)),
    };
}

